// useQuota – a szervezet kvótája (GET /api/quota): a ténylegesen érvényes korlát (saját vagy globális) és a
// foglalt tárhely a Lomtárral és az Archívummal együtt. A feltöltések előzetes (kliensoldali) ellenőrzéséhez;
// a végső döntés mindig a szerveré.
import { useCallback, useEffect, useState } from 'react';
import { ApiClient, type QuotaStatus } from '../api/client';

export function useQuota(enabled = true) {
  const [quota, setQuota] = useState<QuotaStatus | null>(null);
  const reload = useCallback(async () => {
    const r = await ApiClient.getQuota().catch(() => null);
    if (r?.ok && r.data) setQuota(r.data);
    window.dispatchEvent(new CustomEvent('quota:changed-local'));
  }, []);
  useEffect(() => { if (enabled) reload(); }, [enabled, reload]);
  /** MB; 0 = korlátlan */
  const limitMb = quota ? quota.storage.limit_mb : null;
  return { quota, reload, limitMb, usedBytes: quota ? quota.storage.total : null };
}
